import script from "./CallPonButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CallPonButton.vue?vue&type=script&setup=true&lang=js"

import "./CallPonButton.vue?vue&type=style&index=0&id=14f8dbed&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f8dbed"]])

export default __exports__